import Service from '@/utils/request';
import HomeworkApi from './homework';

/**
 * 农业地块管理相关接口（对齐 cloud-pilot-web AgriPlot 模块）
 * 路径前缀：/biz/agri/agriPlot
 */
const NongyeApi = {
    /**
     * 查询地块列表（按名称/时间过滤）
     * @param {AgriPlotQuery} params
     */
    listAgriPlot: (params) => Service.get('/biz/agri/agriPlot/list', { params: { ...params } }),

    /**
     * 查询区域 + 地块树形列表（左侧树结构）
     * @param {AgriPlotQuery} params
     */
    treeAgriPlot: (params) => Service.get('/biz/agri/agriPlot/tree', { params: { ...params } }),

    /**
     * 查询地块详情
     * @param {string|number} id
     */
    getAgriPlot: (id) => Service.get(`/biz/agri/agriPlot/${id}`, {}),

    /**
     * 新增地块
     * @param {AgriPlotForm} data
     */
    addAgriPlot: (data) => Service.post('/biz/agri/agriPlot', { ...data, appCode: 'NY' }),

    /**
     * 修改地块
     * @param {AgriPlotForm} data
     */
    updateAgriPlot: (data) => Service.put('/biz/agri/agriPlot', { ...data, appCode: 'NY' }),

    /**
     * 删除地块
     * @param {string|number} id
     */
    delAgriPlot: (id) => Service.delete(`/biz/agri/agriPlot/${id}`, {}),

    /**
     * 查询地块种植信息列表
     * @param {AgriPlotPlantingQuery} query
     */
    listAgriPlotPlanting: (query) => Service.get('/biz/agri/agriPlotPlanting/list', { params: { ...query } }),

    /**
     * 查询农事过程记录详情
     * @param {string|number} id
     */
    getAgriFarmingRecord: (id) => Service.get(`/biz/agri/agriFarmingRecord/${id}`, {}),

    /**
     * 查询农事过程记录列表（按种植记录ID等条件过滤）
     * @param {AgriFarmingRecordQuery} query
     */
    listAgriFarmingRecord: (query) => Service.get('/biz/agri/agriFarmingRecord/list', { params: { ...query } }),

    /**
     * 查询地块树形列表（按名称过滤）
     * @param {AgriPlotTreeQuery} query
     */
    listAgriPlotTreeBs: (query) => Service.get('/biz/agri/agriPlot/treeBs', { params: { ...query } }),

    /**
     * 查询地块统计信息
     * @param {AgriPlotStatisticQuery} query
     */
    countAgriPlot: (query) => Service.get('/biz/agri/statistic/countTotal', { params: { ...query } }),

    /**
     * 查询地块种植面积统计信息
     * @param {AgriPlotStatisticQuery} query
     */
    countPlantArea: (query) => Service.get('/biz/agri/statistic/countPlantArea', { params: { ...query } }),

    /**
     * 查询地块种植状态统计信息
     * @param {AgriPlotStatisticQuery} query
     */
    countPlantStatus: (query) => Service.get('/biz/agri/statistic/countPlantStatus', { params: { ...query } }),

    /**
     * 查询作物下拉选项（无分页）
     */
    cropOptionList: () => Service.get('/biz/agri/agriCrop/optionList', {}),

    // ========== 农事作业需求（homework） ==========
    getDictList: (dictType) => Service.get(`/system/dict/data/type/${dictType}`),
    listAgriService: HomeworkApi.listAgriService,
    agriServiceStatusCount: HomeworkApi.agriServiceStatusCount,
    getAgriService: HomeworkApi.getAgriService,
    addAgriService: HomeworkApi.addAgriService,
    updateAgriService: HomeworkApi.updateAgriService,
    delAgriService: HomeworkApi.delAgriService,
    createAgriServiceTask: HomeworkApi.createAgriServiceTask,
    exportAgriService: HomeworkApi.exportAgriService,
};

export default NongyeApi;
